module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--3-5cb84217cd956480c2408ed51f4b76ac.jpg";